import { AppStore } from 'store/types';

class StoreRegistry {
  private store?: AppStore;

  getStore() {
    return this.store;
  }

  register(store: AppStore) {
    this.store = store;
  }
}

export default new StoreRegistry();
